import { create } from "zustand";
import { vendorBasicInfoSubmitApi } from "../../services/vendorMaster";
import { useVendorMasterStore } from "../useVendorMasterStore";
const GUID = localStorage.getItem("vendorGUID") || "";

const mapApiToLocationForm = (api) => ({
  vendorGUID: api?.VendorGUID ?? GUID,
  locationCode: api?.LocationCode ?? "",
  location: api?.Location ?? "",
  addressLine1: api?.AddressLine1 ?? "",
  addressLine2: api?.AddressLine2 ?? "",
  addressLine3: api?.AddressLine3 ?? "",
  addressLine4: api?.AddressLine4 ?? "",
  country: api?.Country ?? null,
  state: api?.State ?? null,
  city: api?.City ?? "",
  pincode: api?.Pincode ?? "",
  contactPersonFirstName: api?.ContactPersonFirstName ?? "",
  contactPersonLastName: api?.ContactPersonLastName ?? "",
  contactNumber: api?.ContactNumber ?? "",
  email: api?.Email ?? "",
  alternateContactPersonName: api?.AlternateContactPersonName ?? "",
  alternateContactNumber: api?.AlternateContactNumber ?? "",
  alternateEmail: api?.AlternateEmail ?? "",
  gstRegistration: api?.GSTRegistration ?? null,
  gstRegistrationNumber: api?.GSTRegistrationNumber ?? "",
  legalName: api?.LegalName ?? "",
  fssaiRegistration: api?.FSSAIRegistration ?? null,
  fssaiRegistrationNumber: api?.FSSAIRegistrationNumber ?? "",
  msmeRegistration: api?.MSMERegistration ?? null,
  msmeRegistrationNumber: api?.MSMERegistrationNumber ?? "",
  other: api?.Other ?? "",
});

export const useBasicDataFormStore = create((set, get) => ({
  basicData: {
    vendorGUID: GUID || "",
    locationCode: "",
    location: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    country: null,
    state: null,
    city: "",
    pincode: "",
    contactPersonFirstName: "",
    contactPersonLastName: "",
    contactNumber: "",
    email: "",
    alternateContactPersonName: "",
    alternateContactNumber: "",
    alternateEmail: "",
    gstRegistration: null,
    gstRegistrationNumber: "",
    legalName: "",
    fssaiRegistration: null,
    fssaiRegistrationNumber: "",
    msmeRegistration: null,
    msmeRegistrationNumber: "",
    other: "",
  },

  setLocationData: (api) => {
    set((state) => ({
      basicData: {
        ...state.basicData,
        // addressLine1: api?.addressLine1 ?? "",
        // addressLine2: api?.addressLine2 ?? "",
        // addressLine3: api?.addressLine3 ?? "",
        country: api?.country ?? null,
        // state: api?.state ?? null,
        city: api?.city ?? "",
        // pincode: api?.pincode ?? "",
      },
    }));
  },
  errors: {},
  setBasicDataApi: (api) =>
    set(() => ({
      basicData: mapApiToLocationForm(api),
    })),

  handleInputChange: (field, value) =>
    set((state) => {
      let finalValue = value;

      // If checkbox → boolean
      if (typeof value === "boolean") {
        finalValue = value;
      }

      // Uppercase all strings except vendorGUID
      else if (typeof value === "string") {
        if (field !== "vendorGUID") {
          finalValue = value.toUpperCase();
        }
      }

      return {
        basicData: {
          ...state.basicData,
          [field]: finalValue,
        },
        errors: { ...state.errors, [field]: "" },
      };
    }),

  resetForm: () =>
    set(() => ({
      basicData: {
        vendorGUID: "",
        locationCode: "",
        location: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        country: "",
        state: "",
        city: "",
        pincode: "",
        contactPersonFirstName: "",
        contactPersonLastName: "",
        contactNumber: "",
        email: "",
        alternateContactPersonName: "",
        alternateContactNumber: "",
        alternateEmail: "",
        gstRegistration: null,
        gstRegistrationNumber: "",
        legalName: "",
        fssaiRegistration: null,
        fssaiRegistrationNumber: "",
        msmeRegistration: null,
        msmeRegistrationNumber: "",
        other: "",
      },
      errors: {},
    })),

  setErrors: (errors) => set({ errors }),

  validateForm: () => {
    const { basicData, errors } = get();
    const newErrors = {};
    const { vendorDetailByGuid } = useVendorMasterStore.getState();
    const { VendorType } = vendorDetailByGuid?.Vendor || {};

    // Required fields
    if (!basicData.vendorGUID) newErrors.vendorGUID = "Vendor GUID is required";
    // if (!basicData.locationCode) newErrors.locationCode = "Location Code is required";
    if (!basicData.location) newErrors.location = "Location is required";

    if (!basicData.addressLine1)
      newErrors.addressLine1 = "Address Line 1 is required";
    if (!basicData.addressLine2)
      newErrors.addressLine2 = "Address Line 2 is required";
    if (!basicData.addressLine3)
      newErrors.addressLine3 = "Address Line 3 is required";
    // if (!basicData.addressLine4)
    //   newErrors.addressLine4 = "Address Line 4 is required";
    if (!basicData.country) newErrors.country = "Country is required";
    if (!basicData.state) newErrors.state = "State is required";
    if (!basicData.city) newErrors.city = "City is required";
    if (!basicData.pincode) newErrors.pincode = "Pincode is required";
    if (!basicData.legalName) newErrors.legalName = "Trade Name is required";

    if (!basicData.contactPersonFirstName)
      newErrors.contactPersonFirstName =
        "Contact Person First Name is required";

    if (!basicData.contactNumber)
      newErrors.contactNumber = "Contact Number is required";

    if (!basicData.email) newErrors.email = "Email is required";
    if (errors.email) {
      newErrors.email = errors.email;
    }
    if (errors.alternateEmail) {
      newErrors.alternateEmail = errors.alternateEmail;
    }
    if (basicData.gstRegistration === null)
      newErrors.gstRegistration = "GST Registration is required";

    if (basicData.fssaiRegistration === null && VendorType !== "ZAEX")
      newErrors.fssaiRegistration = "FSSAI Registration is required";

    if (basicData.msmeRegistration === null)
      newErrors.msmeRegistration = "MSME Registration is required";

    if (basicData.gstRegistration && !basicData.gstRegistrationNumber)
      newErrors.gstRegistrationNumber = "GST registration number is required";
    if (errors.gstRegistrationNumber) {
      newErrors.gstRegistrationNumber = errors.gstRegistrationNumber;
    }

    if (basicData.fssaiRegistration && !basicData.fssaiRegistrationNumber)
      newErrors.fssaiRegistrationNumber =
        "FSSAI registration number is required";

    if (basicData.msmeRegistration && !basicData.msmeRegistrationNumber)
      newErrors.msmeRegistrationNumber = "MSME registration number is required";

    // Save & return result
    set({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  },

  submitBasicInfo: async (form) => {
    const { basicData } = get();
    set({ loading: true });
    try {
      const response = await vendorBasicInfoSubmitApi(form);
      set({
        basicData: {
          ...basicData,
          locationCode: response?.Data[0].LocationCode,
        },
      });
      localStorage.setItem("locationCode", response?.Data[0].LocationCode);
      return response?.Data[0];
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },
}));
